/**
 * Presence (SPEC §6.3): awareness publishes { user, editing }; rows show a small
 * initial dot where the other person is editing.
 */
import { useSyncExternalStore } from 'react'
import { sync } from '../sync/doc'

type Editors = Map<string, { name: string; id: string }>

let editors: Editors = new Map()
const subs = new Set<() => void>()

function recompute() {
  const next: Editors = new Map()
  const mine = sync.awareness.clientID
  sync.awareness.getStates().forEach((s, client) => {
    if (client === mine) return
    const st = s as { user?: { id: string; name: string }; editing?: string | null }
    if (st.editing && st.user) next.set(st.editing, { name: st.user.name, id: st.user.id })
  })
  const changed = next.size !== editors.size || [...next].some(([k, v]) => editors.get(k)?.id !== v.id)
  if (changed) {
    editors = next
    for (const f of subs) f()
  }
}

sync.awareness.on('change', recompute)

export function useEditorOf(itemId: string): { name: string; id: string } | undefined {
  return useSyncExternalStore(
    (cb) => {
      subs.add(cb)
      return () => subs.delete(cb)
    },
    () => editors.get(itemId),
  )
}

export function useOnlinePeers(): number {
  return useSyncExternalStore(
    (cb) => {
      const f = () => cb()
      sync.awareness.on('change', f)
      return () => sync.awareness.off('change', f)
    },
    () => Math.max(0, sync.awareness.getStates().size - 1),
  )
}
